import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { DatePipe, Location } from '@angular/common';
import {environment as env} from '../../../environments/environment';
import {LanguageService} from '../../services/language.service';

@Component({ 
  selector: 'app-track-order',
  templateUrl: './track-order.component.html',
  styleUrls: ['./track-order.component.css']
})
export class TrackOrderComponent implements OnInit {
  orderId:any;
  ordDetail:[]=[];
  odrCStates:any[] = [];
  allOStates:any[] = [];
  countSec:number;
  countSec2:number;
  showSdelivery:boolean;
  showEsmDelivery:boolean; 
  showLang:string;
  ordCanStatus:boolean;

  constructor(private route:ActivatedRoute,
    private router:Router,private http:HttpClient, private locn:Location,
    private langObj:LanguageService) {
      this.langObj.langStr.subscribe((data)=>{
        this.showLang = data;
      });
     }

  ngOnInit(): void {

    this.showLang = localStorage.getItem("showLang");
    if(this.showLang == null && this.showLang == undefined){
     this.showLang = 'en';
    }

    this.route.params.subscribe((params:Params)=>{
      if(params['ordid']){
        this.orderId = params['ordid'];
      }else{}
    })

    this.http.post(env.apiurl+'order-detail', {oid:this.orderId}).subscribe(rawData=>{
      this.ordDetail = rawData['data'];

     // console.log(this.ordDetail);

      this.odrCStates = this.ordDetail['OrderStates'];
      this.allOStates = this.ordDetail['allOrderStates'];
      var isSheduleDelivery = rawData['data']['isScheduled'];
      var sDate = rawData['data']['sdate'];
      var time_from = rawData['data']['time_from'];
      var time_to = rawData['data']['time_to'];

      if(isSheduleDelivery){
        if(sDate != null && time_from != null && time_to != null ){
          this.showSdelivery = true;
        }
      }


      var dHrs = rawData['data']['deliveryhours'];
      var dMin = rawData['data']['deliveryminutes'];
      var deliverySetedTime = rawData['data']['deliverysetedTime'];
      let substrings = deliverySetedTime.split(':');
  
      var setedHrs = substrings[0]*60*60;
      var setedMin = substrings[1]*60;
      var totalSetedTime = setedHrs + setedMin;

      if(dHrs != null && dMin != null){
        dHrs = rawData['data']['deliveryhours']*60*60;
        dMin = rawData['data']['deliveryminutes']*60;
        var totalTime = totalSetedTime + dHrs + dMin;
        
        //convert current time to UAE time

        var d = new Date();
        var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
        var ct = new Date(utc + (3600000*4));
        var chrs = ct.getHours() *60*60;
        var cmin = ct.getMinutes()*60;
        var cTotaltime = chrs + cmin;
  
        this.countSec = totalTime - cTotaltime;
        
        if(this.countSec < 0){
          this.countSec = 0;
        }
        if(this.showSdelivery){
          this.showEsmDelivery = false;
        }else{
          this.showEsmDelivery = true;
        }
        
      }

      if(this.ordDetail['order_status'] == 'Delivered'){
        this.showEsmDelivery = false;
        this.showSdelivery = false;
      }

      if(this.ordDetail['order_status'] == '5'){
        this.ordCanStatus = true;
      }


    });

}

backclick(){
  this.locn.back()
}

calcTime(offset) {

  var d = new Date();
  var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
  var nd = new Date(utc + (3600000*offset));
   //return nd.getHours();
   //return nd.getMinutes();
  return  nd.toLocaleString();

}


}
